import { MSG_CAMPO_OBRIGATORIO, MSG_CAMPO_INVALIDO } from 'utils/consts';

// VERIFICA SE EXISTE VALOR
export const isRequired = valor => {
  return valor?.toString()?.trim() ? null : MSG_CAMPO_OBRIGATORIO;
};

// VERIFICA SE TEM A QUANTIDADE MINIMA DE CARACTERES
export const minLength = (valor, min) => {
  return valor?.toString()?.trim()?.length >= min ? null : MSG_CAMPO_INVALIDO;
};

// VERIFICA SE TEM A QUANTIDADE MAXIMA DE CARACTERES
export const maxLength = (valor, max) => {
  return valor?.toString()?.length <= max ? null : MSG_CAMPO_INVALIDO;
};

export const validarEmail = email => {
  // RETORNA TRUE SE O E-MAIL FOR VALIDO
  if (email) {
    const usuario = email.substring(0, email.indexOf('@'));
    const dominio = email.substring(email.indexOf('@') + 1, email.length);
    if (
      usuario.length >= 1 &&
      dominio.length >= 3 &&
      usuario.search('@') === -1 &&
      dominio.search('@') === -1 &&
      usuario.search(' ') === -1 &&
      dominio.search(' ') === -1 &&
      dominio.search('.') !== -1 &&
      dominio.indexOf('.') >= 1 &&
      dominio.lastIndexOf('.') < dominio.length - 1
    ) {
      return true;
    }
  }
  return false;
};
